import React from "react";

// example to check git folders
const SkillSection = ({ title, data }) => {
  return (
    <div className="skill-wrapper">
      <h1>{title}</h1>
      <div className="skill-line">
        {data.map((skill) => {
          const Icon = skill.icon;
          return (
            <div key={skill.id} className="skill-item">
              <Icon size={30} />
              <span>{skill.name}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SkillSection;
